export const BuyingNotificationType = {
  BUYING_SHIPPING_FEE_UPDATED: 203, // 送料が決まった
  BUYING_WAITING_PAYMENT_EXPIRED: 210, // 入金待ち期間が期限切れ
  BUYING_PAYMENT_CONFIRMED: 211, // 支払いが確認できた（現金決済）
  BUYING_SHIPPED: 221, // 発送された
  BUYING_TRACKING_CODE_UPDATED: 223, // 追跡番号が更新された
  BUYING_TRACKING_CODE_DELETED: 225, // 追跡番号が削除された
  BUYING_COMPLETE: 241, // 取引完了
  BUYING_CANCELED: 291, // 取引がキャンセルされた
  BUYING_CANCELED_BY_WAITING_PAYMENT_EXPIRED: 295, // 入金待ち期間が期限切れで取引がキャンセルされた
  BUYING_MESSAGE_RECEIVED: 299, // 取引メッセージが届いた
} as const;
export type BuyingNotificationType = (typeof BuyingNotificationType)[keyof typeof BuyingNotificationType];

export const SellingNotificationType = {
  SELLING_ORDERED: 301, // 注文があった
  SELLING_PAID: 311, // 支払われた
  SELLING_SHIPPING_ALERT: 315, // 発送の催促
  SELLING_COMPLETE: 341, // 取引完了
  SELLING_FEEDBACKED: 342, // 感想コメントが届いた
  SELLING_CANCELED: 391, // 取引がキャンセルされた
  SELLING_CANCELED_BY_WAITING_PAYMENT_EXPIRED: 395, // 入金待ち期間が期限切れで取引がキャンセルされた
  SELLING_MESSAGE_RECEIVED: 399, // 取引メッセージが届いた
} as const;
export type SellingNotificationType = (typeof SellingNotificationType)[keyof typeof SellingNotificationType];

export const NotificationType = {
  ITEM_LIKED: 101, // お気に入りされた
  SHOP_FOLLOWED: 111, // フォローされた
  ...BuyingNotificationType,
  ...SellingNotificationType,
  MESSAGE_RECEIVED: 401, // メッセージが届いた
  ITEM_RESTOCK_REQUESTED: 501, // 商品の再入荷リクエストがあった
  REQUESTING_ITEM_RESTOCKED: 502, // リクエストしていた商品が再入荷された

  NEW_ITEMS: 801, // フォローしているショップに新商品が登録された
  NEW_EVENTS: 802, // フォローしているショップがイベントを登録した

  COUPON_ISSUED: 1001, // クーポンが発行された
  COUPON_EXPIRING: 1007, // クーポンの有効期限が間近

  PRICE_OFF_ITEM_IN_CART: 1101, // カート内商品の値下げ
  PRICE_OFF_ITEM_FROM_FOLLOWING_SHOPS: 1102, // フォローしているショップの作品の値下げ
  PRICE_OFF_ITEM_IN_FAVORITES: 1103, // お気に入り商品の値下げ
} as const;
export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType];
